import { FC } from "react";
import Forbidden from "../components/forbidden/Forbidden";

const ForbiddenPage: FC = () => {
  return <Forbidden />
}

export default ForbiddenPage;